import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import BookRow, { BookCard } from "./BookRow";
import useLoginCheck from "../util/useLoginCheck";
import Spinner from "../util/Spinner";
import { fetchBooks } from "../slice/bookSlice";

const BookTable = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { books, isLoading } = useSelector((state) => state.books);
  const [searchParams] = useSearchParams();
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();

  useLoginCheck();

  const bookTitleMatchesSearch = (book) => {
    return searchText
      ? book?.title?.toLowerCase().includes(searchText.toLowerCase())
      : true;
  };

  useEffect(() => {
    const refreshParam = searchParams.get("refresh") === "true";
    if (refreshParam) {
      dispatch(fetchBooks());
      navigate(window.location.pathname, { replace: true });
    } else {
      dispatch(fetchBooks());
    }
  }, [dispatch, location.search]);

  return (
    <div className="max-w-3xl mx-auto p-4">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="flex justify-end mb-4">
            <button
              className="btn-primary"
              onClick={() => navigate("/books/search")}
            >
              New
            </button>
          </div>
          {books && books.length > 0 ? (
            <div>
              <input
                type="text"
                placeholder="Search"
                className="w-full border border-stone-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-teal-600"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <table className="hidden md:table w-full card">
                <colgroup>
                  <col style={{ width: "55%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "10%" }} />
                </colgroup>
                <thead>
                  <tr className="text-left text-sm text-stone-500 border-b border-stone-200">
                    <th className="px-3 py-2 font-medium">Title</th>
                    <th className="px-3 py-2 font-medium">Author</th>
                    <th className="px-3 py-2 font-medium">Date Read</th>
                    <th className="px-3 py-2 font-medium">Rating</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-200">
                  {books?.filter(bookTitleMatchesSearch).map((book) => (
                    <BookRow key={book.sid} book={book} />
                  ))}
                </tbody>
              </table>
              <ul className="md:hidden space-y-3">
                {books?.filter(bookTitleMatchesSearch).map((book) => (
                  <BookCard key={book.sid} book={book} />
                ))}
              </ul>
            </div>
          ) : (
            <p className="text-stone-500">No books entered</p>
          )}
        </>
      )}
    </div>
  );
};
export default BookTable;
